import { render } from "./YourOrder.vue?vue&type=template&id=4e5fe03b&ts=true"
import script from "./YourOrder.vue?vue&type=script&lang=ts"
export * from "./YourOrder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__